// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import styles from "../../styles/ProfileScreenStyle";
import { fetchUserData } from "../../axios/axiosConfig";
import AsyncStorage from "@react-native-async-storage/async-storage";
const ProfileScreen = ({ getTranslation }) => {
  const [userData, setUserData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await fetchUserData("Driver");
      if (response.status === 200) {
        setUserData(response.data.company);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ScrollView contentContainerStyle={styles.container}>
      {userData ? (
        <View style={styles.dataContainer}>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>
                {getTranslation("Denominazione Sociale")}
              </Text>
              <Text style={styles.value}>{userData.companyName}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>{getTranslation("Via")}</Text>
              <Text style={styles.value}>{userData.address.street}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>{getTranslation("Cap")}</Text>
              <Text style={styles.value}>{userData.address.zipCode}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>{getTranslation("Località")}</Text>
              <Text style={styles.value}>{userData.address.locality}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>{getTranslation("Comune")}</Text>
              <Text style={styles.value}>{userData.address.city}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>{getTranslation("P.IVA")}</Text>
              <Text style={styles.value}>{userData.vatNumber || "-"}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>
                {getTranslation("Codice Fiscale")}
              </Text>
              <Text style={styles.value}>{userData.codiceFiscale}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>
                {getTranslation("Persona di Riferimento")}
              </Text>
              <Text style={styles.value}>
                {userData.mainContact.title} {userData.mainContact.firstName}{" "}
                {userData.mainContact.lastName}
              </Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>{getTranslation("Telefono")}</Text>
              <Text style={styles.value}>{userData.mainContact.phone}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>{getTranslation("Email")}</Text>
              <Text style={styles.value}>{userData.mainContact.email}</Text>
            </View>
          </View>
        </View>
      ) : (
        <Text style={styles.label}>
          {getTranslation("Carimento del profilo attendere...")}
        </Text>
      )}
    </ScrollView>
  );
};

export default ProfileScreen;
